import { useAuth } from "../Context/AuthContext";
import axios from "axios";
// export const API_URL = "http://192.168.0.157:8080";
// export const API_URL = "http://203.175.10.110:8080";
export const API_URL = "https://sarjana.fmas.trisakti.ac.id";

export const useAxios = () => {
  const { logout } = useAuth();

  const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      // Return response normally if successful
      return response;
    },
    (error) => {
      // Handle 401 Unauthorized globally
      if (error.response && error.response.status === 401) {
        console.error("Unauthorized, redirecting to login...");
        logout();
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export const statusPenggunaOptions = [
  { value: 1, label: "AKTIF" },
  { value: 0, label: "TIDAK AKTIF" },
];

export const statusGeneralOptions = [
  { value: 1, label: "AKTIF" },
  { value: 0, label: "TIDAK AKTIF" },
];

export const courseTypeOptions = [
  { value: "", label: "-- PILIH SALAH SATU --" },
  { value: "PERKULIAHAN", label: "PERKULIAHAN" },
  { value: "PRAKTIKUM", label: "PRAKTIKUM" },
  { value: "PLENO", label: "PLENO" },
  { value: "TUTORIAL", label: "TUTORIAL" },
  { value: "KKD", label: "KKD" },
];

export const defaultOptions = [{ value: 0, label: "-- PILIH SALAH SATU --" }];

export const sesiOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
];

export const kelompokModulOptions = [
  { value: 1, label: "Import Excel" },
  { value: 2, label: "Input Manual" },
];

export const rowsPerPageOptions = [10, 25, 50, 100, "All"];

// STATUS KELAS
// 0 = ON SCHEDULE
// 1 = ON GOING
// 2 = FINISHED
// 3 = CANCELED
